/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React from "react";
import styles from "./Backdrop.module.css";
import Button from "@material-ui/core/Button/Button";
import { constant } from "./../../../shared/constants/constants";

// backdrop with refresh button
const Backdrop = props => {
  return props.show ? (
    <div className={styles.Backdrop}>
      <div className={styles.RefreshBtn}>
        <Button variant="contained" onClick={props.clicked}>
          {constant.REFRESH}
        </Button>
      </div>
    </div>
  ) : null;
};

export default Backdrop;
